@import '../../stylesheets/defaults'

+host-styles(mp-confirm)
  position absolute
  width 400px

+prefix-classes('mp-confirm-')
  mp-modal
    width inherit

  .container, .container *
    box-sizing border-box

  .container
    display flex
    flex-direction column

    .body
      display flex
      flex-direction row
      min-height 92px
      padding 24px 24px 0
      text-align left

      .body-content
        width 100%

        .description-newline
          white-space pre-line

          span
            display block
            padding-bottom 8px

    .buttons
      display flex
      justify-content flex-end
      padding 24px

      mp-button
        margin-left 8px

    .mp-input
      margin-top 12px
      width 100%

  .info-banner-bottom
    margin-top 16px
